<template>
  <div class="px-3">
    <h1 class="font--m-3 mb-2">신청 내용</h1>

    <!-- 대출희망금액 -->
    <FormValidationInput
      :disabled="!captureMode"
      :readonly="captureMode"
      :inputValue.sync="form.loanAmount"
      :valid="{ name: '대출희망금액', rules: 'required' }"
      title="대출희망금액"
      placeholder="대출희망금액"
      suffix="만원"
    />

    <!-- 자금용도 -->
    <FormValidationInput
      :disabled="!captureMode"
      :readonly="captureMode"
      :inputValue.sync="form.capitalPurpose"
      :valid="{ name: '자금용도', rules: 'required' }"
      title="자금용도"
      placeholder="자금용도를 입력해주세요"
    />

    <!-- 상환계획 -->
    <FormValidationInput
      :disabled="!captureMode"
      :readonly="captureMode"
      :inputValue.sync="form.repaymentPlan"
      :valid="{ name: '상환계획', rules: 'required' }"
      title="상환계획"
      placeholder="상환계획을 입력해주세요"
    />
  </div>
</template>

<script>
import { commaFormat } from '@/filter/number'
import { toPercentage } from '@/util/mathUtil'
import { mapState } from 'vuex'

export default {
  props: ['request', 'loading'],
  components: {
    FormValidationInput: () => import('@/components/common/form/FormValidationInput.vue'),
  },
  data() {
    return {
      form: {
        // 대출희망금액(만원)
        loanAmount: commaFormat(String(this.request?.amount / 10000)),
        // 자금용도
        capitalPurpose: '운영자금',
        // 상환계획
        repaymentPlan: `일 매출금의 ${toPercentage(
          this.request?.repaymentRatio || 0.2,
          0,
        )}%로 일상환`,
      },
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('ui', ['captureMode']),
  },
  created() {
    // 자금용도 세팅
    this.form.capitalPurpose = this.me?.purposesOfLoan || '운영자금'
  },
}
</script>

<style lang="scss" scoped></style>
